import { render, staticRenderFns } from "./NewChat.vue?vue&type=template&id=4d368843&scoped=true&"
import script from "./NewChat.vue?vue&type=script&lang=js&"
export * from "./NewChat.vue?vue&type=script&lang=js&"
import style0 from "./NewChat.vue?vue&type=style&index=0&id=4d368843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d368843",
  null
  
)

export default component.exports